import * as types from '@/store/mutation-types'
export default {
    namespaced: true,

    state: {
        materialFlowInvoice: []
    },

    actions: {
        fetchTransaction({ commit }, { invoiceType, invoiceId, transactionType }) {
            return window.axios.get(`MaterialFlow/invoice/${invoiceType}/${invoiceId}/transaction/${transactionType}`).then((data) => {
                commit(types.STORE_MATERIAL_FLOW_INVOICE, data)
                return data
            })
        },

        create(_, { invoiceType, invoiceId, entryData }) {
            return window.axios.post(`MaterialFlow/invoice/${invoiceType}/${invoiceId}/transaction`, entryData).then((data) => {
                return data
            })
        },

        update(_, { invoiceType, invoiceId, transactionId, entryData }) {
            return window.axios.put(`MaterialFlow/invoice/${invoiceType}/${invoiceId}/transaction/${transactionId}`, entryData).then((data) => {
                return data
            })
        },

        delete(_, { transactionId }) {
            return window.axios.delete(`MaterialFlow/Invoice/Transaction/${transactionId}`)
        }

    },

    mutations: {
        [types.STORE_MATERIAL_FLOW_INVOICE](state, materialFlowInvoice) {
            state.materialFlowInvoice = materialFlowInvoice
        }
    },

    getters: {}
}